import {
	PaginatedReponse,
	PlanModel,
	Subscription,
	SubscriptionApiResponse,
	SubscriptionDetailModel,
	SubscriptionPaymentUpdateModel,
	SubscriptionPurchaseModel,
} from "../types/subscription";
import Base from "./base";

class SubscriptionAPI extends Base {
	constructor(token: string) {
		super(token, "/api/subscription");
	}

	async getSubscriptions(payload: {
		search?: string;
		page?: number;
		size?: number;
	}): Promise<SubscriptionApiResponse<PaginatedReponse<Subscription>>> {
		payload.page = (payload.page ?? 0) + 1;
		return await this.fetchJsonWithQueryParams("/?", "GET", payload);
	}

	async getSubscriptionById(id: string): Promise<SubscriptionApiResponse<SubscriptionDetailModel>> {
		return await this.fetchJsonWithQueryParams("/" + id, "GET");
	}

	async getSubscriptionsByNodeId(nodeId: string): Promise<SubscriptionApiResponse<Subscription[]>> {
		return await this.fetchJsonWithQueryParams("/available?nodeId=" + nodeId, "GET");
	}

	async getAvailablePlans(payload: { currency?: string }): Promise<SubscriptionApiResponse<PlanModel[]>> {
		return await this.fetchJsonWithQueryParams("/plan?", "GET", payload);
	}

	async getPaymentGateways(payload: {
		currency: string;
		plan: string;
		quantity: number;
	}): Promise<SubscriptionApiResponse> {
		return await this.fetchJsonWithQueryParams("/method?", "GET", payload);
	}

	async purchaseSubscription(payload: {
		plan: string;
		currency: string;
		quantity: number;
		method: string;
	}): Promise<SubscriptionApiResponse<SubscriptionPurchaseModel>> {
		return await this.postJsonWithQueryParams("/purchase?", "POST", payload);
	}

	async upgradeOrDowngradeSubscription(payload: {
		subscriptionId: string;
		quantity: number;
	}): Promise<SubscriptionApiResponse> {
		return await this.postJsonWithQueryParams("/schedule", "POST", payload);
	}

	async cancelScheduledDowngrade(subscriptionId: string): Promise<SubscriptionApiResponse> {
		return await this.postJsonWithQueryParams("/" + subscriptionId + "/schedule", "DELETE");
	}

	async cancelSubscription(subscriptionId: string): Promise<SubscriptionApiResponse<SubscriptionDetailModel>> {
		return await this.postJsonWithQueryParams("/cancel", "POST", {
			subscriptionId: subscriptionId,
		});
	}

	async addNodeToSubscription(payload: { nodeId: string; subscriptionId: string }): Promise<SubscriptionApiResponse> {
		return await this.postJsonWithQueryParams("/node", "POST", payload);
	}

	async removeNodeFromSubscription(payload: {
		nodeId: string;
		subscriptionId: string;
	}): Promise<SubscriptionApiResponse> {
		return await this.postJsonWithQueryParams("/node", "DELETE", payload);
	}

	async reactivateSubscription(subscriptionId: string): Promise<SubscriptionApiResponse<SubscriptionDetailModel>> {
		return await this.postJsonWithQueryParams("/reactivate", "POST", {
			subscriptionId: subscriptionId,
		});
	}

	async updatePaymentMethod(
		subscriptionId: string
	): Promise<SubscriptionApiResponse<SubscriptionPaymentUpdateModel>> {
		const returnUrlBase = window.location.href;

		const body = {
			subscriptionId: subscriptionId,
			returnUrl: returnUrlBase,
		};

		return await this.postJsonWithQueryParams("/payment", "POST", body);
	}
}

export default SubscriptionAPI;
